import { render, staticRenderFns } from "./FileSupport.vue?vue&type=template&id=b5073624&scoped=true"
import script from "./FileSupport.vue?vue&type=script&lang=ts"
export * from "./FileSupport.vue?vue&type=script&lang=ts"
import style0 from "./FileSupport.vue?vue&type=style&index=0&id=b5073624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5073624",
  null
  
)

export default component.exports